"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSelect = require("react-select");
var _reactWordsHighlight = require("react-words-highlight");
var _excluded = ["children", "searchValue"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
// We don't want to apply WordsHighlight to ~2000 options too often, especially at the beginning of the search query
// so we only do it for 1+ chars search queries, when the options are already filtered, to significantly boost performance
var CustomOption = function CustomOption(_ref) {
  var children = _ref.children,
    searchValue = _ref.searchValue,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.Option, props, searchValue && searchValue.length > 1 ? /*#__PURE__*/_react.default.createElement(_reactWordsHighlight.WordsHighlight, {
    text: children,
    query: searchValue,
    highlightTag: "span",
    highlightClassName: "search-term"
  }) : children);
};
var _default = CustomOption;
exports.default = _default;